<template>
<div class="xm-select"
    :class="{ 'is-open': open, 'is-focus': focus }"
    tabindex="0"
    @click="toggle"
    @blur="onBlur"
    @mousedown="onMouseDown"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
>
    <div class="xm-select-label">
        <span v-if="label" class="xm-select-label-left">{{ label }}</span>
        <span v-if="label" class="xm-select-label-sep">：</span>
        <span
            class="xm-select-label-text"
            :class="{ 'is-placeholder': !selectedLabel }"
        >
            {{ selectedLabel || placeholder }}
        </span>
        <i v-if="clearable && hover && value !== undefined && value !== null && value !== ''"
           class="el-icon-error xm-select-clear"
           @click.stop="clearSelect"
        ></i>
        <i :class="['el-icon-arrow-down', 'xm-select-arrow',  { 'is-open': open }]"></i>
    </div>
    <transition name="xm-select-dropdown">
        <ul v-if="open" class="xm-select-dropdown">
            <li v-for="opt in options"
                :key="opt.value"
                :class="['xm-select-option', { selected: opt.value === value }]"
                @click.stop="select(opt)"
                @mousedown.prevent
            >
                <span class="xm-select-option-inner">{{ opt.label }}</span>
            </li>
        </ul>
    </transition>
</div>
</template>

<script>
export default {
    name: 'XmSelect',
    props: {
        options: { type: Array, required: true },
        value: [String, Number, Object],
        label: String,
        placeholder: { type: String, default: '请选择' },
        minWidth: { type: [String, Number], default: 120 },
        clearable: { type: Boolean, default: false }
    },
    data() {
        return {
        open: false,
        focus: false,
        hover: false
        }
    },
    computed: {
        selectedLabel() {
        const found = this.options.find(opt => opt.value === this.value);
        return found ? found.label : '';
        }
    },
    methods: {
        toggle() {
        this.open = !this.open;
        this.focus = true;
        },
        onBlur() {
        this.open = false;
        this.focus = false;
        },
        onMouseDown() {
        this.focus = true;
        },
        select(opt) {
        if (opt.value !== this.value) {
            this.$emit('input', opt.value);
            this.$emit('change', opt.value, opt);
        }
        setTimeout(() => {
            this.open = false;
            this.focus = false;
        }, 300);
        },
        clearSelect() {
        this.$emit('input', '');
        this.$emit('change', '', null);
        this.open = false;
        this.focus = false;
        }
    }
}
</script>

<style scoped>
.xm-select {
    position: relative;
    min-width: 120px;
    width: 100%;
    border: 1px solid rgb(196,205,221);
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
    transition: border 0.2s, box-shadow 0.2s;
    box-sizing: border-box;
    outline: none;
    height: 36px;
    display: flex;
    align-items: center;
    z-index: 0;
}
.xm-select.is-focus,
.xm-select.is-open {
    border: 1px solid #0052d9;
    box-shadow: 0 0 0 2px rgb(217,225,255);
    z-index: 3000;
}
.xm-select:hover {
    border: 1px solid #0052d9;
}
.xm-select-label {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 12px;
    height: 100%;
    user-select: none;
    position: relative;
}
.xm-select-label-left,
.xm-select-label-sep,
.xm-select-label-text {
    font-size: 12px;
}
.xm-select-label-left {
    margin-right: 2px;
    flex-shrink: 0;
}
.xm-select-label-sep {
    margin-right: 2px;
    flex-shrink: 0;
}
.xm-select-label-text {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
    color: #0052d9;
}
.xm-select-label-text.is-placeholder {
    color: #bbb;
}
.xm-select-arrow {
    font-size: 18px;
    color: #c4cddd;
    margin-left: 8px;
    transition: transform 0.2s, color 0.2s;
}
.xm-select.is-open .xm-select-arrow,
.xm-select.is-focus .xm-select-arrow {
    color: #0052d9;
    transform: rotate(180deg);
}
.xm-select-dropdown {
    position: absolute;
    left: 0;
    top: 100%;
    z-index: 3001;
    min-width: 100%;
    background: #fff;
    border: 1px solid #e5e6eb;
    border-radius: 4px;
    margin-top: 4px;
    box-shadow: 0 4px 16px 0 rgba(0,0,0,0.08);
    padding: 5px;
    max-height: 260px;
    overflow-y: auto;
    animation: xm-select-dropdown-fade-in 0.2s;
}
@keyframes xm-select-dropdown-fade-in {
    from { opacity: 0; transform: translateY(-8px);}
    to { opacity: 1; transform: translateY(0);}
}
.xm-select-option {
    padding: 6px 16px;
    margin:6px 0px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 3px;
    font-size: 12px;
    color: #333;
    background: #fff;
    transition: background 0.2s, color 0.2s;
    position: relative;
    overflow: hidden;
}
.xm-select-option.selected {
    color: #0052d9;
    background: #f2f3ff;
}
.xm-select-option.selected .xm-select-option-inner {
    font-weight: bold;
}
.xm-select-option:hover {
    background: #f3f3f3;
}
.xm-select-option:active::before {
    content: '';
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    background: linear-gradient(90deg, #dbe3fa 0%, #b2c5f8 100%);
    opacity: 0.5;
    border-radius: 3px;
    pointer-events: none;
    animation: xm-select-option-active-fill 0.3s;
}

@keyframes xm-select-option-active-fill {
    0% {
        width: 0;
        left: 0;
        right: 100%;
        opacity: 0.5;
    }
    100% {
        width: 100%;
        left: 0;
        right: 0;
        opacity: 0.5;
    }
}
.xm-select-clear {
    font-size: 16px;
    color: #c4cddd;
    margin-left: 8px;
    margin-right: 2px;
    cursor: pointer;
    transition: color 0.2s;
}
.xm-select-clear:hover {
    color: #0052d9;
}
</style>
